module.exports = __webpack_public_path__ + "img/aa9061b6-deff-4336-8dbe-294fcfe7a61a.9f6bb14d.png";